import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  faLightbulbOn,
  faChartUser,
  faUsersGear,
  faAngleUp,
  faAngleDown,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// actions
import { getReports } from '../../actions/reports';

// components
import Tile from './ReportTile';

/* eslint-disable */
function NavButton({ name, icon, activeCategory, setCategory }) {
  const activeStyles = {
    backgroundColor: 'white',
    boxShadow: '0px 0px 1px 0px lightgrey',
    borderRadius: '3px',
    color: 'var(--bs-dark)',
    fontWeight: 'bold',
    textDecoration: 'underline',
  };

  return (
    <div
      role="button"
      className="col-2 p-3 me-3"
      style={ (activeCategory === name) ? activeStyles : {} }
      onClick={() => setCategory(name)}
    >
      <div className="row justify-content-center">
        <FontAwesomeIcon size="2x" icon={icon} />
      </div>
      <div
        className="row justify-content-center"
        style={{ textDecoration: 'capitalize' }}
      >
        {name}
      </div>
    </div>
  );
}

function Hub() {
  const dispatch = useDispatch();
  const {
    user: { is_admin: isAdmin },
    reports: { reports },
  } = useSelector(store => store);
  const [ loading, setLoading ] = useState(false);

  // set default category
  const insightsExist = Boolean(reports.find(r => r.category === 'insights'));
  const marketingExists = Boolean(reports.find(r => r.category === 'marketing_and_sales'));
  const adminExists = Boolean(reports.find(r => r.category === 'administrative'));
  let defaultCategory = 'insights';
  if (insightsExist) {
    defaultCategory = 'insights';
  } else if (marketingExists) {
    defaultCategory = 'marketing_and_sales';
  } else if (adminExists) {
    defaultCategory = 'administrative';
  }

  const [ category, setCategory ] = useState(defaultCategory);
  const [ sortType, setSortType ] = useState('descending'); // ascending or descending

  let sortedReports = [];
  if (sortType === 'ascending') {
    sortedReports = reports.sort((a, b) => {
      if (a.year < b.year) return -1;
      if (a.year > b.year) return 1;
      return 0;
    });
  } else if (sortType === 'descending') {
    sortedReports = reports.sort((a, b) => {
      if (a.year > b.year) return -1;
      if (a.year < b.year) return 1;
      return 0;
    });
  }

  useEffect(() => {
    setLoading(true);
    getReports()
      .then(reports => {
        let filtered = reports;
        // NOTE(santeyio): if this is an admin account we want to display reports
        // that have a NULL agency, as these reports are the 'global' reports.
        // Reports that have an agency specified are agency specific and for
        // 'agent group admins'. The api transparently filters out global reports
        // based on the user being `is_agency_admin`, but will return all reports
        // including agency level reports for `is_admin` users.
        if (isAdmin) filtered = filtered.filter(r => (Boolean(r.agency) === false));
        dispatch({ type: 'SET_REPORTS_KEY', payload: { reports: filtered } });
      }).finally(() => setLoading(false));
  }, []);

  return (
    <main className="p-5">

      <div className="row">
        <div className="col">
          <h2 className="mb-4 font-weight-bold">Analytics Reports</h2>
        </div>
      </div>

      <div className="row mb-4">

        {insightsExist && (
          <NavButton
            name="insights"
            activeCategory={category}
            setCategory={setCategory}
            icon={faLightbulbOn}
          />
        )}
        {marketingExists && (
          <NavButton
            name="marketing_and_sales"
            activeCategory={category}
            setCategory={setCategory}
            icon={faChartUser}
          />
        )}
        {adminExists && (
          <NavButton
            name="administrative"
            activeCategory={category}
            setCategory={setCategory}
            icon={faUsersGear}
          />
        )}

      </div> {/* end row */}

      <div className="row mb-3">
        <div className="col-md-7 fs-3 fw-bold">
          Report Name
        </div>
        <div
          role="button"
          className="col-md-2 fs-3 fw-bold"
          onClick={() => {
            if (sortType === 'ascending') {
              setSortType('descending');
            } else {
              setSortType('ascending');
            }
          }}
        >
          Plan Year
          {(sortType === 'ascending')
            ? <FontAwesomeIcon className="ms-2" icon={faAngleUp} />
            : <FontAwesomeIcon className="ms-2" icon={faAngleDown} />
          }
        </div>
      </div>

      <div className="row">
        {sortedReports.filter(r => (r.category === category)).map((report) => (
          <Tile report={report} />
        ))}
      </div>
    </main>
  );
}

export default Hub;
